import { CourseType } from '@eloomi/eloomi-learning-persona-client/1.0';
import { FilterType, Option } from '@/common/components/filter/interfaces';
import { PageMaxSizeFromApi } from '@/admin/users/providers/user-access-roles';
import { getCategoriesNew, getTopics } from '@/admin/topics/providers';
import { getFullName } from '@/common/services';
import { getGroups } from '@/admin/groups/providers';
import { getListOfCourseAuthors } from '@/admin/courses/providers/authors';
import { getSkillsLite } from '@/admin/skills/providers/course-skills';
import { useLaunchDarkly, useTranslation } from '@/common/composables';

export function useFiltersProvider() {
    const { checkIfLaunchDarklyFeatureEnabled, launchDarklyFeaturesList } = useLaunchDarkly();
    const { trans } = useTranslation();

    const getOptionsList = async (type: FilterType) => {
        let options: Option[] = [];

        switch (type) {
            case FilterType.Author: {
                const result = await getListOfCourseAuthors();
                options = result.map(author => ({
                    value: Number(author.id),
                    label: getFullName(author),
                }));
                break;
            }
            case FilterType.Category: {
                const result = await getCategoriesNew({ page: 1, pageSize: PageMaxSizeFromApi });
                options = (result.data || []).map(
                    category =>
                        ({
                            value: category.id!,
                            label: category.name || '',
                        } as Option)
                );
                break;
            }
            case FilterType.CourseType: {
                options.push(
                    {
                        value: CourseType.Eloomi,
                        label: 'eloomi',
                    },
                    {
                        value: CourseType.Scorm,
                        label: 'SCORM',
                    }
                );
                if (checkIfLaunchDarklyFeatureEnabled(launchDarklyFeaturesList.CONTENT_STORE_POC)) {
                    options.push({
                        value: CourseType.Go1Scorm,
                        label: trans('spa.admin.course-organization.filters-menu.options.course-type.content-store'),
                    });
                }
                break;
            }
            case FilterType.Group: {
                const result = await getGroups({ page: 1, pageSize: PageMaxSizeFromApi });
                options = (result.data || []).map(group => ({
                    value: Number(group.id),
                    label: group.name || '',
                }));
                break;
            }
            case FilterType.Skill: {
                const result = await getSkillsLite({ page: 1, pageSize: PageMaxSizeFromApi });
                options = (result.data || []).map(skill => ({
                    value: skill.id,
                    label: skill.name || '',
                }));
                break;
            }
            case FilterType.Topic: {
                const result = await getTopics({ page: 1, pageSize: PageMaxSizeFromApi });
                options = (result.data || []).map(topic => ({
                    value: topic.id,
                    label: topic.name || '',
                }));
                break;
            }
        }
        return options;
    };

    return { getOptionsList };
}
